import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, ScrollText, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

// Shown at the top of every employee page while any company policy is still
// waiting to be accepted. Red once something is past its deadline (that is
// when leave applications and correction requests get blocked), amber before.
export default function PolicyBanner() {
  const { pathname } = useLocation();
  const { data } = useQuery({
    queryKey: ["myPolicyStatus"],
    queryFn: async () => (await api.get("/my/policies/status")).data,
    refetchInterval: 5 * 60 * 1000,
  });
  if (!data || !data.pending || pathname.startsWith("/policies")) return null;
  const overdue = data.overdue > 0;
  return (
    <Link to="/policies" data-testid="policy-banner"
      className={cn("mb-5 flex items-center gap-3 rounded-lg border px-4 py-3 text-sm transition-colors",
        overdue ? "border-red-300 bg-red-50 text-red-800 hover:bg-red-100" : "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100")}>
      {overdue ? <AlertTriangle className="h-5 w-5 shrink-0" /> : <ScrollText className="h-5 w-5 shrink-0" />}
      <p className="flex-1">
        <span className="font-semibold">You have {data.pending} company {data.pending === 1 ? "policy" : "policies"} to read and accept.</span>{" "}
        {overdue
          ? "The deadline has passed. You can't apply for leave or send correction requests until you accept."
          : "Please do it before the deadline."}
      </p>
      <span className="hidden sm:inline-flex items-center gap-1 font-semibold whitespace-nowrap">Read now <ArrowRight className="h-4 w-4" /></span>
    </Link>
  );
}
